import script from "./GameImages.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameImages.vue?vue&type=script&setup=true&lang=ts"

import "./GameImages.vue?vue&type=style&index=0&id=57da5946&scoped=true&lang=scss"

import exportComponent from "/builds/digithia/escape-game/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57da5946"]])

export default __exports__